var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accepted_modal"},[_c('div',{staticClass:"accepted_modal-title"},[_vm._v(" "+_vm._s(`Год: ${_vm.item.transName}`)+" ")]),(_vm.isShow)?_c('div',{staticClass:"accepted_modal-block"},[_c('GraphicCustomPie',{attrs:{"data":_vm.data,"id":"modal"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }